/* custom.js — theme overrides */

/* ============================================================
   Anime Mega Menu — center on viewport
   ============================================================ */
(function () {
  var twoCol = document.querySelector('.mega-menu--two-column');
  if (!twoCol) return;
  var dropdown = twoCol.closest('.site-nav__dropdown.mega-menu-dropdown');
  if (!dropdown) return;
  var li = dropdown.closest('.site-nav--has-dropdown');
  if (!li) return;

  function center() {
    var liRect = li.getBoundingClientRect();
    var w = Math.min(1200, window.innerWidth);
    var offset = (window.innerWidth - w) / 2 - liRect.left;
    dropdown.style.setProperty('left', offset + 'px', 'important');
  }

  li.addEventListener('mouseenter', center);
  window.addEventListener('resize', function () {
    if (dropdown.offsetParent) center();
  });
})();

/* ============================================================
   Contact Page — Placeholder Overrides
   ============================================================
   Shopify's {% form 'contact' %} renders inputs via snippets
   whose placeholders come from theme translations. Rather than
   forking vendor snippets, we override placeholders client-side
   for the contact page only.
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('ContactForm');
  if (!form) return;

  // Phone input — country prefix hint
  var phoneInput = form.querySelector('input[type="tel"]');
  if (phoneInput) {
    phoneInput.setAttribute('placeholder', '91');
  }

  // Message textarea
  var messageTextarea = form.querySelector('textarea');
  if (messageTextarea) {
    messageTextarea.setAttribute(
      'placeholder',
      "Tell us what you\u2019re chasing, what you\u2019re curious about, or what we can help with."
    );
  }

  // Email input
  var emailInput = form.querySelector('input[type="email"]');
  if (emailInput) {
    emailInput.setAttribute('placeholder', 'you@email.com');
  }

  // Submit button text
  var submitBtn = form.querySelector('button[type="submit"]');
  if (submitBtn) {
    submitBtn.textContent = 'Send Message';
  }
});

/* ============================================================
   Product Card — 360° Hover Video
   ============================================================
   Plays the product's MP4 video on hover (desktop only).
   Video src is deferred via data-video-src to avoid loading
   until the first hover event.
   ============================================================ */
(function () {
  /* Bail on touch-only devices — no hover, no point loading video */
  if (window.matchMedia('(hover: none)').matches) return;

  function initHoverVideos(root) {
    var cards = (root || document).querySelectorAll(
      '.grid__image:not([data-hover-video-bound])'
    );

    cards.forEach(function (card) {
      var video = card.querySelector('.product-card__hover-video');
      if (!video) return;

      card.setAttribute('data-hover-video-bound', '');

      card.addEventListener('mouseenter', function () {
        /* Lazy-load src on first hover */
        if (!video.src && video.dataset.videoSrc) {
          video.src = video.dataset.videoSrc;
        }
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () { /* autoplay blocked — silent fail */ });
        }
      });

      card.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  /* Bind on initial load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHoverVideos(); });
  } else {
    initHoverVideos();
  }

  /* Re-bind after AJAX / infinite scroll inserts new cards */
  var grid = document.getElementById('CollectionProductGrid') ||
             document.querySelector('.collection-products');
  if (grid) {
    new MutationObserver(function () { initHoverVideos(grid); })
      .observe(grid, { childList: true, subtree: true });
  }

  /* Theme editor: re-bind when sections reload */
  document.addEventListener('shopify:section:load', function (e) {
    initHoverVideos(e.target);
  });
})();

/* ============================================================
   "Buy it now" → "Kollekt Now"
   ============================================================
   Shopify's dynamic checkout button is rendered by the platform,
   not the theme. We observe the DOM and replace the text once
   the button appears.
   ============================================================ */
(function () {
  function renameBuyNow() {
    document.querySelectorAll('.shopify-payment-button__button [role="button"], .shopify-payment-button__button').forEach(function (el) {
      if (el.textContent.trim().toLowerCase().indexOf('buy') === 0) {
        el.textContent = 'Kollekt Now';
      }
    });
  }

  /* Run on load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(renameBuyNow, 500); });
  } else {
    setTimeout(renameBuyNow, 500);
  }

  /* Observe for late-rendering dynamic checkout button */
  var buyBtnObserver = new MutationObserver(function () { renameBuyNow(); });
  var target = document.querySelector('.shopify-payment-button') || document.body;
  buyBtnObserver.observe(target, { childList: true, subtree: true, characterData: true });
})();

/* ============================================================
   Quick Add Circle Button — Cart Handler (Persistent State)
   ============================================================
   Intercepts the circle button form submission (capture phase)
   so the compiled product-card component doesn't also handle it.
   Shows a compact spinner during the fetch, then a persistent
   green checkmark while the item remains in the cart.
   On page load, syncs all buttons with the current cart state.
   Listens for cart updates (removals) to revert buttons to plus.
   ============================================================ */
(function () {
  var CHECK_SVG =
    '<svg viewBox="0 0 14 14" width="14" height="14">' +
    '<path d="M2 7l3.5 3.5L12 3" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  /* Capture the server-rendered plus icon HTML from the first button found */
  var PLUS_HTML = '';
  function capturePlusIcon() {
    if (PLUS_HTML) return;
    var firstBtn = document.querySelector('.quick-add-circle-btn:not(.is-added):not(.is-loading)');
    if (firstBtn) PLUS_HTML = firstBtn.innerHTML;
  }

  /* -----------------------------------------------------------
     Sync all circle buttons with current cart contents
     ----------------------------------------------------------- */
  function syncCircleButtons(cartItems) {
    capturePlusIcon();
    var inCart = new Set();
    cartItems.forEach(function (item) { inCart.add(String(item.variant_id)); });

    var forms = document.querySelectorAll('.quick-add-circle-wrap form');
    forms.forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      var btn = form.querySelector('.quick-add-circle-btn');
      if (!input || !btn || btn.classList.contains('is-loading')) return;

      var vid = String(input.value);
      if (inCart.has(vid)) {
        btn.classList.add('is-added');
        btn.innerHTML = CHECK_SVG;
      } else {
        btn.classList.remove('is-added');
        btn.innerHTML = PLUS_HTML || btn.innerHTML;
      }
    });
  }

  /* Fetch cart and sync all buttons */
  function fetchCartAndSync() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncCircleButtons(cart.items); })
      .catch(function (err) { console.error('[quick-add-circle] cart sync failed', err); });
  }

  /* -----------------------------------------------------------
     Initial sync on page load
     ----------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndSync);
  } else {
    fetchCartAndSync();
  }

  /* -----------------------------------------------------------
     Re-sync when new product cards are inserted (AJAX / infinite scroll)
     ----------------------------------------------------------- */
  var grid = document.getElementById('CollectionProductGrid') ||
             document.querySelector('.collection-products');
  if (grid) {
    new MutationObserver(function () { fetchCartAndSync(); })
      .observe(grid, { childList: true, subtree: true });
  }

  /* -----------------------------------------------------------
     Re-sync when cart changes (item removed from drawer, etc.)
     ----------------------------------------------------------- */
  document.addEventListener('wetheme-cart-update', fetchCartAndSync);

  /* Theme editor: re-sync when sections reload */
  document.addEventListener('shopify:section:load', function () { fetchCartAndSync(); });

  /* -----------------------------------------------------------
     Form submission handler (capture phase)
     ----------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest('.quick-add-circle-wrap')) return;

    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('.quick-add-circle-btn');
    if (!btn || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    capturePlusIcon();
    var variantId = form.querySelector('input[name="id"]').value;
    var sectionsInput = form.querySelector('input[name="sections"]');

    btn.classList.add('is-loading');
    btn.innerHTML = '<span class="circle-spinner"></span>';

    var payload = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (sectionsInput) payload.sections = sectionsInput.value;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        /* Update cart drawer */
        if (window.eventBus) {
          window.eventBus.emit('update:cart:drawer', data);
        }

        /* Update cart count */
        fetch(window.routes.cart_url + '?view=compare')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (window.wetheme && window.wetheme.updateCartCount) {
              window.wetheme.updateCartCount(cart);
            }
          });

        /* Persistent checkmark — stays until item is removed from cart */
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.innerHTML = CHECK_SVG;

        /* Open cart drawer */
        if (window.eventBus) {
          window.eventBus.emit('open:cart:drawer');
        }
      })
      .catch(function (err) {
        console.error('[quick-add-circle]', err);
        btn.classList.remove('is-loading');
        btn.innerHTML = PLUS_HTML || btn.innerHTML;
      });
  }, true); /* capture phase — runs before product-card component */
})();
